import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { List } from 'immutable'
import ImagePin from '@aytm/lib/rfd-ui/components/basic/image-pin'

import '@aytm/lib/rfd-ui/styles/advanced/image-gallery.scss'
import classNames from 'classnames'

ImageGallery.propTypes = {
  imageList: PropTypes.instanceOf(List).isRequired,
  hideIcons: PropTypes.bool,
  value: PropTypes.number,
  onChange: PropTypes.func
}

export function ImageGallery({ imageList, hideIcons, onChange, value } = {}) {
  const [current, setCurrent] = useState(value)
  const [opened, setOpened] = useState(0)

  const onClick = value => {
    if (onChange) onChange(imageList.getIn([value, 'original_url']), value)
    setCurrent(value)
    setOpened(value)
  }

  return (
    <div
      className={classNames('rfd-ui-image-gallery', {
        hideIcons: hideIcons,
        showIcons: !hideIcons
      })}
    >
      {hideIcons ? (
        <ImagePin
          previewURL={imageList.getIn([current, 'trimmed_path'])}
          baseUrl={imageList.getIn([current, 'original_url'])}
          closeOnClick={false}
          withPincher={false}
          withZoom={false}
          withPopup={!('function' == typeof onChange)}
        />
      ) : (
        imageList.map((image, i) => (
          <div className={current == i ? `current` : ``} key={'galleryImage' + i}>
            {'view3d' == image.get('original_url') ? (
              <div className={classNames('view3d', { opened: i == opened })} onClick={() => onClick(i)}>
                <i className="icon-aytmfd-qshelf-ar" />
              </div>
            ) : (
              <ImageGalleryItem
                previewURL={image.getIn(['trimmed_path'])}
                onChange={onClick}
                withPopup={!('function' == typeof onChange)}
                index={i}
                opened={i == opened && hideIcons}
                baseUrl={i == opened ? imageList.getIn([current, 'original_url']) : image.getIn(['original_url'])}
              />
            )}
          </div>
        ))
      )}
    </div>
  )
}

export default React.memo(ImageGallery, (prev, next) => prev.imageList === next.imageList)

const ImageGalleryItem = React.memo(
  props => {
    const { index, onChange, previewURL, baseUrl, withPopup } = props

    return (
      <ImagePin
        baseURL={baseUrl}
        previewURL={previewURL}
        closeOnClick={false}
        withPincher={false}
        withPopup={withPopup}
        onClick={() => {
          onChange(index)
        }}
      />
    )
  },
  (prev, next) => prev.baseUrl === next.baseUrl
)

ImageGalleryItem.displayName = 'ImageGalleryItem'

ImageGalleryItem.propTypes = {
  index: PropTypes.number.isRequired,
  baseUrl: PropTypes.string.isRequired,
  onChange: PropTypes.any.isRequired,
  withPopup: PropTypes.bool.isRequired,
  previewURL: PropTypes.any.isRequired
}
